module.exports = __webpack_public_path__ + "img/pointcard-btn.af79350a.png";